import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from './ui/Alert';
import { setPushHandlers } from '../lib/pushNotifications';

// Lives inside <RouterProvider> so it can call useNavigate. AuthContext kicks
// off registration above the router; this just wires the foreground/tap
// handlers into the running app once the router exists.
export function PushNotificationsBridge() {
  const { toast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    setPushHandlers({
      onReceived: (n) => {
        // Foreground notification — surface as an info toast so the user
        // doesn't have to swipe down the system tray to see it.
        const msg = n.title ? `${n.title}: ${n.body ?? ''}` : (n.body ?? 'New notification');
        toast('info', msg.trim());
      },
      onAction: (a) => {
        // Server-side payload can include a `path` to deep-link to, e.g.
        // `/<storeId>/orders/<orderId>`. Anything else just opens the app.
        const path = (a.notification.data as { path?: string } | undefined)?.path;
        if (typeof path === 'string' && path.startsWith('/')) {
          navigate(path);
        }
      },
    });
    return () => setPushHandlers({});
  }, [toast, navigate]);

  return null;
}
